<template lang="pug">
    .modal-mask
        .modal-container.reveal-modal(:class="[{'open': showing}, modalWidth, modalTopMargin, classes]" :style="topCss")
            header.draggable(data-draggable-modal="")
                .title
                    slot(name="header")
            .content
                slot(name="content")

            .close-modal(@click="$emit('close')") ×
        .modal-background(@click="$emit('close')" :class="{'open': showing}")
</template>

<script>
    export default {
        data() {
            return {
                showing: true,
                topCss: 0
            }
        },
        props: {
            classes: null,
            showModal: {
                type: Boolean,
                default: true
            },
            modalWidth: {
                validator: function (value) {
                    return ['', 'tiny', 'small', 'medium', 'large', 'x-large'].indexOf(value) !== -1
                },
                default: ''
            },
            modalTopMargin: {
                validator: function (value) {
                    return ['', 'student_transfer'].indexOf(value) !== -1
                },
                default: '',
            },
            top: {
                type: Boolean,
                default: true
            },
            height: {
                type: Number,
                default: 0
            }
        },
        computed: {},
        methods: {
            close() {
                this.showing = false
            }
        },
        watch: {
            showModal: {
                immediate: true,
                handler: function (value) {
                    if (this.top) this.topCss = `top:  ${(window.pageYOffset + 50 - this.height)/16}rem;`
                    this.showing = value
                }

            }
        }
    }
</script>

<style scoped lang="scss">
    .reveal-modal{
        margin-left: 0 !important;
    }
    /*use this for making title/content of the modal centered*/
    .centered{
        text-align: center;
    }

    .modal-container {
        position: absolute;
        opacity: 0;
        visibility: hidden;
        left: 50%;
        height: auto;
        border-radius: 4px;
        overflow: hidden;
        z-index: -1;
        background: white;
        padding: 0;
        box-shadow: 0 4px 20px rgba(227, 227, 227, 0.5);
        transform: translate(-50%);
        transition: all 0.2s ease-in-out;

        &.open {
            visibility: visible;
            display: block;
            opacity: 1;
            z-index: 1061;
            .float-placeholder {
              &.active {
                z-index: 1062;
              }
            }
        }

        header {
            background-color: #476da7;
            border-bottom: 1px solid #f5f7fa;
            padding: 1rem 1.25rem;

            .title {
                color: #fff;
                font-weight: 500;
                font-size: 1.375rem;
                line-height: 1.25rem;
            }
        }

        .content {
            padding: 1.25rem;

            small {
                font-size: 0.75rem;
                line-height: 1;
            }
        }
    }

    .close-modal {
        position: absolute;
        font-size: 1.8em;
        line-height: 0.8;
        top: 0.625em;
        right: 0.6875em;
        color: white;
        font-weight: bold;
        cursor: pointer;
    }

    .modal-background {
        position: fixed;
        visibility: hidden;
        opacity: 0;
        height: 100%;
        width: 100%;
        background: #254264;
        background: rgba(37, 66, 100, 0.45);
        z-index: -1;
        display: none;
        top: 0;
        left: 0;
        transition: all 0.2s ease-in-out;
        
        &.open {
            z-index: 1060;
            display: block;
            visibility: visible;
            opacity: 1;
        }
    }

    .tiny {
        width: 30%;
    }

    .small {
        width: 40%;
    }

    .medium {
        width: 37.5rem;
    }

    .large {
        width: 70%;
    }

    .x-large {
        width: 95%;
    }
    
    .student_transfer .draggable{
      margin-left: -7px !important;
    }
    .ncsa_modal{
      header{
        background-color:#fff;
        padding-bottom: 0;
        border-bottom: 3px solid #476da7;
        .title{
          font-size: 16px;
          color: #66737f;
          font-weight: 600;
        }
      }
    }
</style>
